import React, { forwardRef, useState } from 'react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

interface PasswordInputProps {
  id: string;
  isRequired?: boolean;
  autoComplete?: string;
  name?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleKeyboardButton: (e: React.KeyboardEvent<HTMLInputElement>, isEmailInput: boolean) => void;
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(({
  id = 'password', isRequired = true, autoComplete, name, onChange, handleKeyboardButton,
}, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <input
        id={id}
        ref={ref}
        required={isRequired}
        autoComplete={autoComplete}
        type={showPassword ? 'text' : 'password'}
        name={name}
        onChange={onChange}
        onKeyDown={(e) => handleKeyboardButton(e, false)}
        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm"
      />
      <div
        role="button"
        tabIndex={-1}
        onClick={() => setShowPassword(!showPassword)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            setShowPassword(!showPassword);
          }
        }}
        className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 cursor-pointer"
      >
        {showPassword ? <EyeSlashIcon className="h-5 w-5 text-gray-400" /> : <EyeIcon className="h-5 w-5 text-gray-400" />}
      </div>
    </div>
  );
});

export default PasswordInput;
